import { render } from "./product-upload.vue?vue&type=template&id=16c37b45&scoped=true"
import script from "./product-upload.vue?vue&type=script&lang=js"
export * from "./product-upload.vue?vue&type=script&lang=js"

import "./product-upload.vue?vue&type=style&index=0&id=16c37b45&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c37b45"]])

export default __exports__